import { css } from "lit";

export const holloAudioPlayerStyles = css`
  :host {
    --hollo-audio-pp-bg: #000000;
    --hollo-audio-pp-icon: #ffffff;
    --hollo-audio-track: #9ca3af;
    --hollo-audio-thumb: #ffffff;
    --hollo-audio-thumb-shadow: rgba(0, 0, 0, 0.2);
    --hollo-audio-time: #6b7280;
  }
  .hollo-wrap {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    max-width: 320px;
    min-width: 240px;
  }
  .hollo-pp {
    width: 28px;
    height: 28px;
    border: none;
    border-radius: 999px;
    background: var(--hollo-audio-pp-bg);
    cursor: pointer;
    position: relative;
    flex-shrink: 0;
  }
  .hollo-pp.hollo-play::before {
    content: "";
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    border-style: solid;
    border-width: 7px 0 7px 11px;
    border-color: transparent transparent transparent var(--hollo-audio-pp-icon);
  }
  .hollo-pp.hollo-pause::before,
  .hollo-pp.hollo-pause::after {
    content: "";
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 4px;
    height: 14px;
    background: var(--hollo-audio-pp-icon);
  }
  .hollo-pp.hollo-pause::before {
    left: 8px;
  }
  .hollo-pp.hollo-pause::after {
    right: 8px;
  }
  .hollo-scrub-bar {
    position: relative;
    flex: 1;
    height: 2px;
    cursor: pointer;
    touch-action: none;
    user-select: none;
  }
  .hollo-scrub-track {
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    height: 2px;
    background: var(--hollo-audio-track);
    border-radius: 1px;
    transform: translateY(-50%);
  }
  .hollo-scrub-thumb {
    position: absolute;
    top: 50%;
    width: 16px;
    height: 16px;
    background: var(--hollo-audio-thumb);
    border-radius: 50%;
    transform: translate(-50%, -50%);
    pointer-events: none;
    box-shadow: 0 1px 3px var(--hollo-audio-thumb-shadow);
  }
  .hollo-wave {
    min-width: 180px;
    flex: 1;
  }
  .hollo-time {
    font-size: 12px;
    color: var(--hollo-audio-time);
    min-width: 40px;
    text-align: right;
    flex-shrink: 0;
  }
  .hollo-audio-player.hollo-isAiVoice {
    display: none;
  }
`;
